<template>
    <div>
        <div :class="{'dropdown-content': !inline, 'dropdown-content-padded': !inline}">
            <div class="grid-content">
                <div class="grid-item grid-item-half">
                    <r-input
                        label="Min"
                        :auto-focus="autoFocus"
                        :value="initialMinimum"
                        :validate="$v.min"
                        @input="updateMin"
                        @key-submit="updateFilter"
                    />
                </div>
                <div class="grid-item grid-item-half">
                    <r-input
                        label="Max"
                        :value="initialMaximum"
                        :validate="$v.max"
                        @input="updateMax"
                        @key-submit="updateFilter"
                    />
                </div>
                <div class="grid-item grid-item-full">
                    <v-error-messages :has-frontend-errors="$v.$error">
                        <li class="list-item" v-if="!$v.min.decimal">The minimum value must be numeric</li>
                        <li class="list-item" v-if="!$v.max.decimal">The maximum value must be numeric</li>
                        <li class="list-item" v-if="!$v.min.optionalBetween || !$v.max.optionalBetween">The minimum
                            value must be lower or equal to the maximum value.
                        </li>
                    </v-error-messages>
                </div>
            </div>
        </div>
        <slot v-if="$slots.footer" name="footer"/>
        <filter-footer v-else @update="updateFilter"/>
    </div>
</template>

<script>
    import vErrorMessages from '@/components/form/v-error-messages';
    import decimal from 'vuelidate/lib/validators/decimal';
    import optionalBetween from '@/components/vuelidate/validators/optional-between';
    import _ from '@/common/helpers';
    import filterMixins from './filter-mixins';
    import FilterFooter from './filter-footer';

    export default {
        mixins: [filterMixins],
        components: {FilterFooter, vErrorMessages},
        computed: {
            initialMinimum() {
                const values = this.adapter.getInitialFilterValue(this.filter);
                return values ? values.min : null;
            },
            initialMaximum() {
                const values = this.adapter.getInitialFilterValue(this.filter);
                return values ? values.max : null;
            },
        },
        data() {
            return {
                min: null,
                max: null,
            };
        },
        validations: {
            /* eslint-disable func-names */
            min: {
                decimal,
                optionalBetween: optionalBetween('max', function (min) {
                    return min <= this.max;
                }),
            },
            max: {
                decimal,
                optionalBetween: optionalBetween('min', function (max) {
                    return max >= this.min;
                }),
            },
        },
        methods: {
            makePayload() {
                return this.adapter.getFilterPayload({
                    index: this.index,
                    filter: this.filter,
                    data: this.preparePayloadData(),
                });
            },
            handleInput() {
                if (!this.inline) {
                    return;
                }
                this.$v.$touch();
                if (!this.$v.$error) {
                    const payload = this.makePayload();
                    this.$emit('update', payload);
                }
            },
            updateMin(value) {
                this.min = +value;
                this.handleInput();
            },
            updateMax(value) {
                this.max = +value;
                this.handleInput();
            },
            updateFilter() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    const payload = this.makePayload();
                    this.$emit('update', payload);
                    this.$parent.$emit('request-popper-hide');
                }
            },
            preparePayloadData() {
                const data = {min: null, max: null};
                if (_.isBlank(this.min)) {
                    data.max = Number(this.max);
                } else if (_.isBlank(this.max)) {
                    data.min = Number(this.min);
                } else {
                    data.min = Number(this.min);
                    data.max = Number(this.max);
                }
                return data;
            },
            focusFilter() {
                this.$el.querySelector('input').focus();
            },
        },
        mounted() {
            this.min = this.initialMinimum;
            this.max = this.initialMaximum;
        },
    };
</script>
